<template>
  <div>
    <el-row :gutter="12">
        <el-col :span="12" >
            <el-upload
        class="upload-demo"
        ref="upload"
        :action="uploadUrl"
        multiple
        drag
        :auto-upload="false"
        :file-list="fileList"
        :on-change="fileLoad"
        accept=".xls,.xlsx"
        :show-file-list="niuws"
        :on-success="fileChange"
        >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em>
          <br/>
          已选择{{fileList.length}}个附件,点击确定上传完成
        </div>
        </el-upload>
        </el-col>
        <el-col :span="12" style="padding-left: 12px">
            <div style="padding-left: 12px">
              <el-button size="small" type="success" @click="submitUpload">确定上传</el-button>
            </div>
            <div class="uploadTip-title">
              <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-tishi"></use>
              </svg>
              温馨提示
            </div>
        <div class="uploadTip-lists">
            <div class="uploadTip-list">
            1、支持文件后缀 xls、xlsx文件，且不超过10M
            </div>
            <div class="uploadTip-list">
            2、请将要上传的内容放在第一个sheet中
            </div>
            <div class="uploadTip-list">
            3、第一个sheet中首行必须为表头，且不支持复合表头
            </div>
            <div class="uploadTip-list">
            4、请不要加密模板文件，将导致错误
            </div>
        </div>
        </el-col>
    </el-row>
    <!-- <el-row :gutter="12">
        <el-col style="margin-top: 10px" :span="8" v-for="fileObj in fileObj" :key="fileObj.fileId">
            <el-card shadow="hover" @click="down">
                <div class="hes"><span>{{fileObj.name}}</span></div>
                <el-button type="primary" size="mini" @click="toFileLa">导出</el-button>
                <el-button type="primary" size="mini">删除</el-button>
            </el-card>
        </el-col>
    </el-row> -->
  </div>
</template>

<script>
  import {saveUseBalance} from "@/api/biz/bill/pay-notice"
  import {queryPubOrgList} from "@/api/orig-biz/pub-org-account"
  import { floatSum, floatSub } from "@/util/util";
  import {mapGetters} from 'vuex';
  import {updatePayTemplate} from "@/api/biz/bill/pay-notice"
  
  export default {
    name: "payOrder",
    props:{
      balanceInfo:{
        type: Object,
        default: () => ({})
      },
      clickRow:{
        type: Object,
        default: () => ({})
      },
      balanceLists: {
        type: Array,
        default: () =>([])
      },
      balanceListsCopy: {
        type: Array,
        default: () =>([])
      },
      balanceListsCopy2: {
        type: Array,
        default: () =>([])
      },
      kyBalanceList: {
        type: Array,
        default: () =>([])
      },
    },
    computed: {
    },
    created() {
        this.fileObj = [];
    },
    data(){
      return{
          uploadUrl: "/api/file",//导入地址/api/biz/batchInfo/export
          // uploadUrl: "/api/biz/batchInfo/uploadFilesOnLocal",//导入地址
          niuws: false,
          fileList: [],
          fileObj: []
      }
    },
    methods: {
        // 文件提交
        submitUpload() {
            this.$refs.upload.submit();
        },
        // 文件发生变化
        fileLoad(file, fileList) {
          if (file.status != 'success') {
            this.fileList = fileList;
          }
        },
        // 文件上传至服务器成功
        fileChange(res, file, fileList) {
            if (res) {
                if(res.fileId){
                    // this.$message.success(file.name+' 文件上传成功');
                    this.fileObj.push(res);
                } else {
                    this.$message.error('文件上传失败');
                }
            } else {
                this.$message.error('文件上传失败');
            }
        },
        // 更新模板信息
        toFileLa() {
            let templateIds = '';
            this.fileObj.forEach(item => {
                templateIds += item.fileId + ','
            })
            templateIds = templateIds.substring(0,templateIds.length-1);
            updatePayTemplate({cusNum: this.clickRow.id, templateId: templateIds}).then(res => {
                if(res.data.code==0) {
                    this.$message.success("模板上传成功");
                    this.fileObj = [];
                    this.$emit('payOrderDialog',{
                      id: this.clickRow.id,
                      templateId: templateIds
                    });
                }
            })
        }
    },
    filters: {
      
    },
    mounted(){

    },
    watch: {
        fileList(newValue, oldValue) {
        },
        // 监听文件是否全部上传成功,全部成功调用更新接口
        fileObj(newValue, oldValue) {
          if (this.fileList.length == newValue.length && newValue.length != 0) {
            this.toFileLa();
            this.fileList = [];
            this.$refs.upload.clearFiles();
          }
        }
    },
  };
</script>

<style scoped rel="stylesheet/scss">
.hes {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
 .stepContent {
  }

  .download {
    display: flex;
    justify-content: flex-end;
  }

  .download p {
    margin-left: 20px;
    line-height: 50px;
    color: #269cff;
    cursor: pointer;
  }

  .download p svg {
    margin-right: 10px;
  }

  .download p:hover {
    text-decoration: underline;
  }

  .uploadBox {
    border-radius: 5px;
    margin-bottom: 20px;
  }

  .uploadContent {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
  }

  .uploadContent .iconfont {
    font-size: 80px;
    color: #cccccc;
  }

  .uploadBox >>> .el-upload {
    width: 100%;
    height: 100%;
  }

  .uploadBox >>> .el-upload-dragger {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .uploadBox >>> .el-upload-dragger .el-icon-upload {
    margin-top: 0;
  }

  .uploadText {
    color: #aaaaaa;
  }



  .uploadTip-lists {
    padding-left: 20px;
  }


  .uploadTip-list .uploadTip-button {
    color: #269cff;
    text-decoration: underline;
    cursor: pointer;
  }

  .next-btn {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

</style>
